import * as React from 'react';

import arrowDownSrc from './assets/arrowDown.png';

export const arrowDownIcon = <img width={24} height={24} src={arrowDownSrc} />;
